import React from 'react';
import { View, Text } from 'react-native';
import type { FeedbackPriority } from '@/lib/admin/types';

const PRIORITY_CONFIG: Record<FeedbackPriority, { label: string; color: string }> = {
  low: { label: 'Low', color: '#8E8E93' },
  medium: { label: 'Medium', color: '#00B8B8' },
  high: { label: 'High', color: '#FF9500' },
  critical: { label: 'Critical', color: '#FF3B30' },
};

interface FeedbackPriorityBadgeProps {
  priority: FeedbackPriority;
  size?: 'sm' | 'md';
}

export function FeedbackPriorityBadge({ priority, size = 'sm' }: FeedbackPriorityBadgeProps) {
  const config = PRIORITY_CONFIG[priority];
  const isSmall = size === 'sm';

  return (
    <View className={`flex-row items-center gap-1.5 ${isSmall ? '' : 'px-2 py-0.5'}`}>
      <View
        className={`rounded-full ${isSmall ? 'w-2 h-2' : 'w-2.5 h-2.5'}`}
        style={{ backgroundColor: config.color }}
      />
      <Text
        style={{ color: config.color }}
        className={`font-semibold ${isSmall ? 'text-[10px]' : 'text-xs'}`}
      >
        {config.label}
      </Text>
    </View>
  );
}
